import type { ShopProductResponseDto } from "~/common/interfaces/dto/shop/shop-product-response.dto";

export const getProductWithItemsDefault = (): ShopProductResponseDto => ({
	id: 0,
	name: "",
	description: "",
	feature: {
		useCustomText: false,
		customTextPrice: 0,
		materialOrderIds: []
	},
	kind: {
		id: 0,
		name: ""
	},
	materials: [],
	sizes: [],
	collections: [],
	tags: [],
	imageIds: [],
	items: []
});
